// This file is auto-generated by @hey-api/openapi-ts

export const ChallengeWindowSizeEnum = {
    1: '01',
    2: '02',
    3: '03',
    4: '04',
    5: '05'
} as const;

export type ChallengeWindowSizeEnum = typeof ChallengeWindowSizeEnum[keyof typeof ChallengeWindowSizeEnum];
